/**
 * @generated SignedSource<<99cf90e2c6a16e89fe9b18af79e5d87d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_ListView_project$data = {
  readonly key: string;
  readonly projectId: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"ui_nativeIssueTable_NativeIssueTable_project">;
  readonly " $fragmentType": "main_issueNavigator_ListView_project";
};
export type main_issueNavigator_ListView_project$key = {
  readonly " $data"?: main_issueNavigator_ListView_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_ListView_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "main_issueNavigator_ListView_project",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "kind": "ScalarField",
      "name": "projectId"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isConditionalFormattingEnabled",
          "variableName": "isConditionalFormattingEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ui_nativeIssueTable_NativeIssueTable_project"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "16fb0fbe06ef444bfb0b7c8b5141bdd1";

export default node;
